import Translate from "../../../utils/Translate";
import { Button, Stack } from "@mui/material";
import KeyIcon from "@mui/icons-material/Key";
import BankIdAuthentication from "../../bankId/BankIdAuthentication";
import { useApi } from "../../../utils/Api";
import { useState } from "react";

const BankIdLoginForm = ({
  onLoginSuccess,
  startQrCodeOnDesktop,
  onlyBankIdLogin,
}) => {
  const api = useApi();
  const [bankIdCancelUrl, setBankIdCancelUrl] = useState();

  const onAuthenticationSuccess = (loginType, response) => {
    localStorage.setItem("eportLoginMethod", "bankId_" + loginType); // spara för att visa bankidinloggning vid nästa inloggning
    onLoginSuccess(response.data);
  };

  const onStatusInitiated = (bankIdStatusResponse) => setBankIdCancelUrl(bankIdStatusResponse.cancelUrl);

  const cancelBankIdLogin = async () => {
    await api.fetch(bankIdCancelUrl, null, "POST", false);
  };

  function getLoginUrl() {
    return window.global.isEcomp
      ? `${import.meta.env.VITE_AUTH_URL}auth/bankid/login/digital-licenses`
      : `${import.meta.env.VITE_AUTH_URL}auth/bankid/login/courseadmin`;
  }

  return (
    <form className="loginForm">
      <BankIdAuthentication
        startAuthenticationUrl={getLoginUrl()}
        onStatusInitiated={onStatusInitiated}
        onAuthenticationSuccess={onAuthenticationSuccess}
        startQrCodeOnDesktop={startQrCodeOnDesktop}
        classNameButtonTextOverride={window.global.isKs ? "grayButtonText roundFlatButton" : null}
        classNameButtonContainedOverride={window.global.isKs ? "grayYellowButtonContained roundFlatButton" : null}
      />
      {!onlyBankIdLogin && (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent={window.global.isKs ? "center" : "flex-start"}
          paddingTop={1}
          paddingBottom={2}
        >
          <Button
            href="/login"
            onClick={cancelBankIdLogin}
            startIcon={<KeyIcon />}
            className={window.global.isKs ? "grayButtonText roundFlatButton" : null}
          >
            {Translate.get("LogInUsingEmail")}
          </Button>
        </Stack>
      )}
    </form>
  );
};

export default BankIdLoginForm;
